// 業務上の「今日」と日付表示は日本時間で揃える（ブラウザの時計やUTCに引きずられない）。
const JST = 'Asia/Tokyo';

/** 日本時間の今日 "YYYY-MM-DD"。 */
export const todayJst = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: JST }).format(new Date());

/** UTCのタイムスタンプ（ISO文字列やDate）を日本時間の日付 "YYYY-MM-DD" に。 */
export const jstDate = (ts) => {
  if (!ts) return '';
  const s = String(ts);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;     // 日付だけの値はずらさない
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s.slice(0, 10);
  return new Intl.DateTimeFormat('en-CA', { timeZone: JST }).format(d);
};

/** 日本時間での表示用。日付だけの値も時差でずれない。 */
export const formatJst = (ts, opts = {}) => {
  if (!ts) return '';
  const s = String(ts);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(s) ? new Date(`${s}T00:00:00+09:00`) : new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return new Intl.DateTimeFormat('ja-JP', { timeZone: JST, ...opts }).format(d);
};

/** 保存はUTC・表示はJST。「2026-10-19 12:39」の形。 */
export const jstDateTime = (ts, withSeconds = false) => {
  if (!ts) return '';
  const s = String(ts);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  const p = new Intl.DateTimeFormat('en-CA', {
    timeZone: JST, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', ...(withSeconds ? { second: '2-digit' } : {}),
  }).formatToParts(d).reduce((a, x) => ({ ...a, [x.type]: x.value }), {});
  const hm = `${p.hour === '24' ? '00' : p.hour}:${p.minute}`;
  return `${p.year}-${p.month}-${p.day} ${hm}${withSeconds ? `:${p.second}` : ''}`;
};

/** 一覧向けの短い形「10-19 12:39」。 */
export const jstDateTimeShort = (ts) => jstDateTime(ts).slice(5);

/** 日本時間の今日から n 日後 "YYYY-MM-DD"。 */
export const addDaysJst = (n) => {
  const [y, m, d] = todayJst().split('-').map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + n));
  return t.toISOString().slice(0, 10);              // UTC基準で組んだ値なのでズレない
};

export default todayJst;
